<template>
  <div class="container">
    <div class="content">
      <p class="arti_title">{{exhibition.title}}</p>
      <p class="arti_metas">
        <span class="arti_author">{{exhibition.author}}</span>
        <span class="arti_date">{{exhibition.date}}</span>
        <span class="arti_type">{{exhibition.type}}</span>
      </p>
      <div align="center">
        <a :href="exhibition.link || noLink"><img :src="exhibition.img" alt /></a>
      </div>
      <p class="arti_content">{{exhibition.content}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExhibitionContent",
  data() {
    return {
      id: 0,
      exhibition: {},
      noLink:"#"
    };
  },
  methods: {
    searchExhibitionById() {
      this.$http
        .post("/v2/SearchExhibition", { id: this.id })
        .then(res => {
          console.log(res.data);
          this.exhibition = res.data;
          this.count = res.count;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.searchExhibitionById();
  },
  mounted() {}
};
</script>

<style scoped>
.container {
  margin-top: 80px;
  margin-bottom: 80px;
}
.content {
  font-family: Arial, "Microsoft YaHei" !important;
  padding: 0 10%;
}

.arti_metas {
  text-align: center;
  padding: 10px;
}
.arti_metas span {
  margin: 0 5px;
  font-size: 14px;
  color: #787878;
}
.arti_title {
  font-size: 33px;
  font-weight: bold;
  text-align: center;
}

.arti_content {
  margin-top: 2%;
  line-height: 1.8;
  white-space: pre-wrap;
}
</style>